<template>
  <div class="result">
    <div class="result-container">
      <div class="result-wrapper">
        <div class="result-header">
          <!--公司logo-->
          <div class="company-logo">
            <img src="./images/logo.png" alt="丰巢logo">
          </div>

          <!--角色台词-->
          <div class="character-text">
            <!--用户昵称-->
            <div class="user-info">
              <div class="user-image">
                <img v-bind:src="avatarUrl + '?' + new Date().getTime() " 
                    alt="用户头像" id="avatar"/>
              </div>
            </div>

            <div></div>
            <!--用户类型-->
            <div class="user-type-container">
              <div class="user-type">
                <div class="user-type-decoration">
                  <p></p>
                </div>
                <div class="user-type-text">{{ characters[index].name}}</div>
                <div class="user-type-decoration">
                  <p></p>
                </div>
              </div>
            </div>

            <!--用户文案-->
            <div class="user-text" v-html="characters[this.index].text">
            </div>
          </div>

          <!--角色-->  
          <div class="character-image">
            <img v-bind:src="characters[index].imageLink" 
                v-bind:alt="characters[index].name">
          </div>
        </div>

        <div class="result-footer">
          <div class="graph"></div>
          <div class="analysis-container">
          </div>
        </div>
      </div>
    </div>

    <!--二维码-->
    <img src="./images/qrcode.png" alt="二维码" style="display: none;" id="qrcode"/>
    <div class="result-save">
      长按图片保存分享
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/lib/chart/radar";
let html2canvas = require("./html2canvas.min.js").html2canvas;
export default {
  name: "result",
  created () {
    let info = localStorage.getItem("info");
    if(info) {
      info = JSON.parse(info);
      this.index = info.cnt ? info.cnt : 0;
      if(this.index > 4) {
        this.index = 4;
      }
      if(info.avatarUrl) {
        if(this.isLinkAvailable(info.avatarUrl)) {
          this.avatarUrl = info.avatarUrl;
        }   
      }
    }
  },
  data () {
    return {
      characters: [
        {
          grade: 0,
          name: "憨豆型巢人",
          imageLink: require("./images/characters/bean.png"),
          text: "我有个憨憨的梦想，<br/>努力创造我的简单生活",
          analysis: {
            observation: 6,
            reasoning: 5,
            memory: 6,
            imagination: 5,
            intelligence: 6,
            technique: 6,
          }
        },
        {
          grade: 1,
          name: "007型巢人",
          imageLink: require("./images/characters/007.png"),
          text: "机关巧妙算尽，<br/>不如生活简单自在！",
          analysis: {
            observation: 7,
            reasoning: 7,
            memory: 7,
            imagination: 6.5,
            intelligence: 7.5,
            technique: 8,
          }
        },
        {
          grade: 2,
          name: "狄仁杰型巢人",
          imageLink: require("./images/characters/direnjie.png"),
          text: "我就是个化繁为简的破案<br/>高手！元芳，你怎么看？",
          analysis: {
            observation: 7.5,
            reasoning: 8,
            memory: 7,
            imagination: 8.4,
            intelligence: 8.8,
            technique: 6,
          }
        },
        {
          grade: 3,
          name: "柯南型巢人",
          imageLink: require("./images/characters/conan.png"),
          text: "侦探世界里，<br/>真相我说了算！",
          analysis: {
            observation: 8,
            reasoning: 8.5,
            memory: 6,
            imagination: 7.5,
            intelligence: 7,
            technique: 7,
          }
        },
        {
          grade: 4,
          name: "福尔摩斯型巢人",
          imageLink: require("./images/characters/sherlock.png"),
          text: "就算大家都爱模仿我，<br/>我还是我，简单的我！",
          analysis: {
            observation: 8,
            reasoning: 9,
            memory: 8,
            imagination: 8.5,
            intelligence: 8.5,
            technique: 8,
          }
        },
      ],
      index: 0,
      avatarUrl: require("./images/avatar.png"),
    }
  },
  methods: {
    isLinkAvailable (url) {
      if(/(http)|(https)/.test(url)) {
        return true;
      } else {
        return false;
      }
    },
    /* 绘制雷达图 */
    drawRadar () {
      let graph = document.querySelector(".graph"),
      radar = echarts.init(graph),
      analysis = this.characters[this.index].analysis;
      radar.setOption({
        radar: {
          name: {
            textStyle: {
              color: '#fff',
              padding: [-12, -10],
            }
          },
          indicator: [
            { name: '观察', max: 10},
            { name: '推理', max: 10},
            { name: '记忆', max: 10},
            { name: '想象', max: 10},
            { name: '智慧', max: 10},
            { name: '技巧', max: 10}
          ]
        },
        animation: false,
        series: [{
          type: 'radar',
          data : [{
            value : [
              analysis.observation,
              analysis.reasoning,
              analysis.memory,
              analysis.imagination, 
              analysis.intelligence, 
              analysis.technique,                         
            ],
          },]
        }],
      });
    },
    /* 长按保存图片 */
    saveImage () {
      let result = document.querySelector(".result-container"),
          width = result.offsetWidth,
          height = result.offsetHeight, 
          canvas = document.createElement("canvas"),
          scale = 2; 

      canvas.width = width * scale; 
      canvas.height = height * scale; 
      canvas.getContext("2d").scale(scale, scale); 

      let opts = {
          scale: scale, 
          canvas: canvas,
          useCORS:true,      // 允许图片跨域
          logging: false, 
          width: width, 
          height: height,
      }, that = this;
      html2canvas(result, opts).then(function(canvas) {
        canvas = that.drawQrcode(canvas, that.qrcodeUrl);   // 绘制二维码
        let imageUrl = canvas.toDataURL("image/jpeg"),
            image = new Image(); 
        image.style.cssText = "position: fixed; left: 0; top:0; z-index: 10000;width: 100%;height: 100%; opacity: 0;";
        image.src = imageUrl;
        result.parentElement.appendChild(image);
      });
    },
    /* 绘制二维码 */
    drawQrcode (canvas, imageUrl) {
      let ratio = 2,
          ctx = canvas.getContext("2d"),
          image = document.querySelector("#qrcode"),
          wrapperHeight = document.querySelector(".result-wrapper").clientHeight,
          wrapperWidth = document.querySelector(".result-wrapper").clientWidth,
          footHeight = document.querySelector(".result-footer").clientHeight,
          graphWidth = document.querySelector(".graph").clientWidth;

      let qrcodeX = graphWidth + (wrapperWidth - graphWidth) / 2 - 140 / ratio,
          qrcodeY = wrapperHeight + footHeight / 2 - 100/ ratio;
      ctx.drawImage(image, 0, 0, 
                image.width, image.height,
                qrcodeX * ratio, qrcodeY* ratio,    // canvas画布坐标
                282, 200); // 图片缩放比例
      return canvas;
    },
     /* 设置保存按钮的位置 */
    setBtnPosition () {
      let saveBtn = document.querySelector(".result-save"),
          saveBtnHeight = saveBtn.clientHeight,
          footerHeight = document.querySelector(".result-footer").clientHeight;
      
      saveBtn.style.bottom = footerHeight / 2 - saveBtnHeight / 2+ "px";
    }
  },
  computed: {
  },
  mounted () {
    this.setBtnPosition();
    this.drawRadar();
    /* 保存图片 */
    let avatar = document.querySelector("#avatar");
    avatar.onload = () => {
      window.setTimeout( () => {
        this.saveImage();
      }, 1000); 
    }
  },
}
</script>

<style lang="scss">
@import "./result.scss";
</style>




// WEBPACK FOOTER //
// src/pages/result/result.vue